import { Builder } from "@builder.io/react";
import { buildColorDesignTokens } from "./__internal__/buildColorDesignTokens";
import { buildTypographyDesignTokensFromFontRamp } from "./__internal__/buildTypographyDesignTokensFromFontRamp";
export var registerBuilderDesignTokens = function() {
    Builder.register("editor.settings", {
        designTokens: {
            fontFamily: buildTypographyDesignTokensFromFontRamp(),
            colors: buildColorDesignTokens()
        }
    });
};
